<template lang="">
    <div>
      <transition name="slide2">
      <div class="positionPanel" v-if="selected.length > 0">
        <div class="containerreporting">
            <div>
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-btn :href="urlbase()" class="mx-2" fab large v-on="on" color="primary">
                            <v-icon dark>mdi-file-pdf</v-icon>
                        </v-btn>
                    </template>
                    <span>Reportes pdf</span>
                </v-tooltip>
              </div>

            <div v-if="user == 'desarrollador' || user == 'administrador'">
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-btn @click.prevent="dialog=true" class="mx-2" fab dark large v-on="on" color="#292626">
                            <v-icon >mdi-delete</v-icon>
                        </v-btn>
                    </template>
                    <span>Borrar registros</span>
                </v-tooltip>
          </div>
        </div>
      </div>
      </transition>
   <v-dialog
      v-model="dialog"
      width="500"
    >
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Eliminar
        </v-card-title>

        <v-card-text>
          ¿Esta seguro que quiere eliminar estos registros?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="deleted"
          >
            si
          </v-btn>
          <v-btn
            color="secundary"
            text
            @click="dialog = false"
          >
            no
          </v-btn>


        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>
    
</template>
<script>
import pdf from "vue-pdf";

//import jsPDF from "jspdf";
//import '../../../../../../../assets/js/jspdf-autoload'
import {url_web} from '../../../../../../../services/url';
import {PDF} from '../../../../../../../services/pdf/pdf'
import {DeleteRegistro} from '../../../../../../../services/register/lista'


console.log(url_web);
export default {
  components: {
    pdf
  },

  data() {
    return {
      currentPage: 0,
      pageCount: 0,
      items:'',
      filter:'',
      urlpdf:'',
      dialog:false
    };
  },

  computed: {
    selected() {
      return this.items = this.$store.getters.select_registro_pdf;
    },

    filters(){
      return this.filter = this.$store.getters.select_registro_filter;
    },

    user(){
      return this.$store.state.currentUser.user.type;
    }
  },

  methods: {

    urlbase:function(){
      return `${url_web}print-pdf/${this.items}/${this.filters}`;
    },

    mostrar:function(){
      PDF({items:this.selected}).then(response=>{
        console.log(response)
      }).catch(errors=>{
        console.log(errors);
      })
    },

    deleted:function(){
      DeleteRegistro(this.selected).then(response=>{
        console.log('exito al borrar');
        this.$toastr.success('Se ha eliminado los registros')
        this.$store.dispatch('deleteregistro');
        this.items = [];
        location.reload(true);
        this.dialog = false;
      }).catch(errors=>{
        this.$toastr.success(errors)
        console.log('error al eliminar');
      })
    }


  },

  
};
</script>
<style>
.positionPanel {
  position: fixed;
  bottom: 40px;
  right: 20px;
}

.positionPanel2{
  position: fixed;
  bottom: 40px;
  right: 100px;
}

.containerreporting{
  display: flex;
}

</style>